export default "__VITE_ASSET__BXgQ5FRQ__"